import { useTheme } from 'styled-components';

import { getThemeValue } from 'styled/helpers';

const useMartyTheme = () => {
  const theme = useTheme();

  return { theme, themed: (value: string) => getThemeValue(value, theme) };
};

export default useMartyTheme;
